// KD-3848 — the page sections an answer cites. The API sends the factsheet's
// section titles; the hotel and experience pages mark each section with
// data-assistant-section (several titles split by "|"), and "booking" marks
// the booking module.

// Factsheet titles (koob-api domain/*Factsheet.ts) with a label of their own.
// Others (a hotel's description sections) are DMC names, shown as written.
const SECTION_KEYS = {
  'General information': 'generalInformation',
  Description: 'description',
  Summary: 'summary',
  'Contracting Conditions': 'contractingConditions',
  Location: 'location',
  Rooms: 'rooms',
  'Services & facilities': 'servicesFacilities',
  'Sustainable commitments': 'sustainableCommitments',
  Restaurants: 'restaurants',
  'Meeting Rooms': 'meetingRooms',
  'Travel Details': 'travelDetails',
  Program: 'program',
  Highlights: 'highlights',
  'Location extra information': 'locationExtraInformation',
  'Free visit information': 'freeVisitInformation',
  'Other remarks': 'otherRemarks',
  'Luggage Policies': 'luggagePolicies',
  'Included services': 'includedServices',
  'Excluded services': 'excludedServices',
  Extras: 'extras',
};

export const sectionLabel = (t, title) =>
  SECTION_KEYS[title] ? t(`sections.${SECTION_KEYS[title]}`) : title;

export const findSection = title =>
  [...document.querySelectorAll('[data-assistant-section]')].find(element =>
    element.dataset.assistantSection.split('|').includes(title),
  );

const HIGHLIGHT = ['ring-2', 'ring-brand/40', 'ring-offset-4', 'rounded-lg'];

/** Scrolls the page to the section and outlines it for a moment. */
export function scrollToSection(title) {
  const element = findSection(title);
  if (!element) return;
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Clears the sticky app bar.
  element.style.scrollMarginTop = '140px';
  element.scrollIntoView({
    behavior: still ? 'auto' : 'smooth',
    block: 'start',
  });
  element.classList.add(...HIGHLIGHT);
  setTimeout(() => element.classList.remove(...HIGHLIGHT), 1800);
}
